import { useAuthStoreShallow } from "@/features/authentication";
import { useAppSelector } from "@store";
import { useEffect, useRef } from "react";

interface IProps {
  accept: string;
  multiple?: boolean;
}

export const useMediaLibOpenFilePicker = ({ accept, multiple }: IProps) => {
  const inputRef = useRef<null | HTMLInputElement>(null);
  const isAdmin = useAuthStoreShallow((s) => s.isAdmin);

  const openFilePicker = (callback: (files: File[]) => Promise<void>) => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = multiple ?? false;
    input.accept = !isAdmin
      ? accept
      : `${accept},font/*,.woff,.woff2,.ttf,.otf`;
    input.style.display = "hidden";

    if (inputRef.current) {
      inputRef.current.remove();
    }
    inputRef.current = document.body.appendChild(input);

    input.onchange = async () => {
      const fileList = input.files;
      if (!fileList) return;

      const files: File[] = [];
      for (let i = 0; i < fileList.length; i++) {
        files.push(fileList[i]);
      }

      if (files.length > 0) {
        await callback(files);
      }

      input.remove();
    };

    input.click();
  };

  useEffect(() => {
    return () => {
      if (inputRef.current) {
        inputRef.current.remove();
      }
    };
  }, []);

  return { openFilePicker };
};
